import { useParams } from "react-router"
import { BlocksRenderer } from "@strapi/blocks-react-renderer"
import { useEffect, useState } from "react"
import { getBlog, getImageUrl } from "../api/strapi"

function Blog() {
    let { blogId } = useParams()
    let [blog, setBlog] = useState([
        {
            __component: 'meow'
        }
    ])
    let [title, setTitle] = useState("meow")

    useEffect(() => {
        getBlog(blogId).then(data => {
            console.log(data)
            setBlog(data.blog)
            setTitle(data.title)
        })
    }, [])

    return (
        <div>
            <div className='lg:mx-52 md:mx-24 mx-4 lg:px-16 px-4 pt-12 text-3xl pb-32 bg-black bg-opacity-40 text-white'>
                <div className="lg:mx-52 md:mx-12 mx-4 line-effect mb-8">
                    <p className='stretched-text lg:text-9xl text-7xl w-full font-stretch-ultra-expanded'>{title}</p>
                </div>
                <div className="lg:px-52 px-4">


                    {
                        blog.map(content => {
                            if (content.__component == "shared.image") {
                                return <div className="block my-8">
                                    <img className="m-auto lg:w-2/3 w-full" src={getImageUrl(content.image.url)}></img>
                                    <span className="lg:w-2/3 w-full m-auto block text-center text-2xl text-white italic">{content.caption}</span>
                                </div>
                            }
                            if (content.__component == "shared.blog-text") {
                                return <BlocksRenderer
                                    content={content.text}
                                    blocks={{
                                        heading: ({ children, level }) => {
                                            switch (level) {
                                                case 1:
                                                    return <h1 variant="h1" className=" font-bold text-6xl">{children}</h1>
                                                case 2:
                                                    return <h2 variant="h2" className=" font-bold text-5xl">{children}</h2>
                                                case 3:
                                                    return <h3 variant="h3" className=" font-bold text-4xl">{children}</h3>
                                                case 4:
                                                    return <h4 variant="h4" className=" font-bold">{children}</h4>
                                            }
                                            // You can use the default components to set class names...
                                            // ...or point to a design system
                                            // For links, you may want to use the component from your router or framework
                                        },
                                        list: (format) => {
                                            return format.children.map(child => {
                                                console.log(child.props.content.children[0].text)
                                                return <span className="block mt-4 ml-8">• {child.props.content.children[0].text}</span>
                                            })
                                        }
                                    }}
                                    modifiers={{
                                        bold: ({ children }) => <div className="text-center py-8">
                                            <span className="font-bold text-3xl">{children}</span>
                                        </div>,
                                        italic: ({ children }) => <span className=" text-purple-200 italic">{children}</span>,
                                        underline: ({ children }) => <div className=" border-t-2 border-b-2 text-center py-4">
                                            <span className=" text-6xl font-bold block">⍁</span>
                                            <span className="font-thin italic">{children}</span>
                                        </div>
                                    }}
                                />
                            }
                        })
                    }
                </div>



            </div>

        </div>
    )
}

export default Blog